<template>
	<section class="small-12 columns projectedReturn" v-if="property">
		<div class="small-12 widget">
			<div class="small-12 widgetTitle flex vertical-align">
				<h2 class="small-12 flex vertical-align"> 
					Return Profile 
					<span class="flex vertical-align">This Year</span>
				</h2>
			</div>
			<ul class="small-12 flex borderRadius8">
				<li class="small-12">
					<percentage-chart-trending :chartValue="0" :is_revenue="false" :chartLabel="'Cap Rate'"/>
				</li>
				<li class="small-12">
					<percentage-chart-trending :chartValue="0" :is_revenue="false" :chartLabel="'Cash on Cash'"/>
				</li>
				<li class="small-12">
					<percentage-chart-trending :chartValue="0" :is_revenue="false" :chartLabel="'Gross Rent Multiplier'"/>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the components
	import PercentageChartTrending from '@/components/framework/charts/PercentageChartTrending.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ProjectedReturn',

		/*
		**  Register the components
		*/

		components: {

			PercentageChartTrending

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fempty-line-chart.svg?alt=media&token=d507b560-c902-4c93-9a32-fb0245c114d5'

		}),

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>